<template>
  <div
    class="tray w-90 p-2 d-flex flex-column justify-content-start align-items-center overflow-auto"
  >
    <div
      class="w-100 p-1 f-tile d-flex justify-content-between align-items-center"
      v-for="item in dataList"
      v-bind:key="item.id"
    >
      <div class="file-details d-flex align-items-center">
        <img
          class="m-1 mr-3"
          src="../assets/folder.png"
          height="25"
          width="25"
          alt="folder"
        />
        <div>
          <p>{{ item.file.name }}</p>
          <div class="sub-text d-flex align-items-end">
            <p class="pr-4">{{ (item.file.size / 1024).toFixed(2) }} KB</p>
          </div>
        </div>
      </div>
      <div class="cp-auto">
        <img
          class="m-1"
          src="../assets/trash.png"
          height="20"
          width="20"
          alt="status"
          @click="
            () => {
              removeFile(item.file.name);
            }
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["type"],
  data() {
    return {
      dataList: this.$store.state.trackData.currentDataList,
    };
  },

  components: {},

  computed: {
    ...mapState(["apiEvents"], ["trackData"]),
  },
  methods: {
    uploadStatus(item) {
      return item.uploadStatus === 0
        ? "../assets/wait.png"
        : "../assets/done.png";
    },
    removeFile(name) {
      if (this.$props.type == "ref") {
        this.$store
          .dispatch("trackData/removeRefFile", { fileName: name })
          .then(() => {});
      } else if (this.$props.type == "track") {
        this.$store
          .dispatch("trackData/removeTrackFile", { fileName: name })
          .then(() => {});
      }
    },
  },
};
</script>

<style scoped>
.f-tile {
  margin: 5px 0px;
  border-radius: 7px;
  background-color: #ffffff;
}

.f-tile p {
  color: rgb(0, 0, 0);
  font-size: 12px;
  margin: 0 !important;
}

.sub-text p:nth-child(1) {
  font-size: 11px;
  color: rgb(92, 92, 92);
}

.sub-text p:nth-child(2),
.sub-text p:nth-child(3) {
  color: rgb(167, 167, 167) !important;
  font-size: 9px !important;
}

.tray {
  background-color: rgb(224, 224, 224);
  border-radius: 14px;
  height: 450px !important;
  /* width: 500px !important;  */
}
</style>
